import React, { Fragment } from 'react';
import { Card, Row, Col } from 'antd';
import List from './components/List';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import './index.css';

const Analytics = () => {
  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[{ name: 'Bảng điều khiển', path: '/dashboard' }]}
        />
      </div>
      <Row>
        <Col span={24}>
          <List />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default Analytics;
